export default __webpack_public_path__ + "static/media/pic_2.bb73262f.webp";